import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { OeAppPersonService } from './oe-app-person.service';
import { OeAppService } from './oe-app.service';
import { Store } from './store';
import { PersonDataDto } from './types/PersonDataDto';

@Injectable({providedIn: 'root'})
export class ProfileLiteExtService extends Store<PersonDataDto> {
  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService
  ) {
    super(null);
    this.getPersonData$().subscribe();
  }

  getPersonData$(refetch: boolean = false): Observable<PersonDataDto> {
    if (refetch || this.state === null) {
      return this.fetchData$().pipe(tap(data => {
        this.setState(data);
      }));
    }

    return this.state$;
  }

  private fetchData$(): Observable<PersonDataDto> {
    return this.http.get<PersonDataDto>(
      `${this.oeAppService.oeProfileServiceHost}/v1/profile/person/lite/${this.oeAppPersonService.id}`
    );
  }
}


// WEBPACK FOOTER //
// ./ts/app/shared/profile-lite-ext.service.ts